import { useContext } from 'react';
import { AuthContext } from '../Context/AuthContext';

const SessaoAuth = () => {
  return useContext(AuthContext);
}

export default SessaoAuth
